module.exports = __webpack_public_path__ + "img/06.6e5e245b.jpg";